import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Estis iu braman’ el Bremeno, <br/>
        Kiu en pantalon’ sen rimeno <br/>
        Provis veni al Hal’, <br/>
        Sed okazis skandal: <br/>
        Estis lia aspekto obscena.
      </p>

      <p class="poem-block mb-3">
        Estis brava braman’ el Bremeno, <br/>
        Kiu rajdis sur granda baleno. <br/>
        Post subita ekplonĝ’ <br/>
        Malaperis la sonĝ’, <br/>
        Restis lito sur fund’ de l’baseno. 
      </p>

      <p class="poem-block mb-3">
        La sendorma braman’ el Bremeno <br/>
        Volis dormi sur mola kuseno… <br/>
        Kun terura brueg’ <br/>
        Lin ĉirkaŭis la greg’: <br/>
        Ŝafoj venis por nokta promeno.
      </p>
      
      <p class="poem-block mb-3">
        Iu povra braman’ el Bremeno <br/>
        Sidis longe en la kvaranteno. <br/>
        Revis li pri vakcin’, <br/>
        Sed en morb-halucin’ <br/>
        La vakcino okazis veneno.
      </p>

      <p class="poem-block mb-3">
        La edzin' de l' bramano Bremena <br/>
        Volis pelton el felo ermena. <br/>
        Petis ŝi kun persist’ <br/>
        Sed rifuzis ĉasist’: <br/>
        Ĉaso estis por li granda ĝeno.
      </p>

      <p class="poem-block mb-3">
        Iu sperta jogan’ el Bremeno <br/>
        Longe sidis sur akra aleno. <br/>
        Estis brava hero’, <br/>
        Sed penegis li tro: <br/>
        Fine trafis al joga Edeno.
      </p>
      
      <p class="poem-block mb-3">
        Iu saĝa braman’ el Bremeno <br/>
        Malsukcesis en la ekzameno. <br/>
        Sed lin savis aŭdac’: <br/>
        Al la ĉefo donac’ – <br/>
        Kaj li restis sur sia posteno.
      </p>

      <p class="poem-block mb-3">
        Iu pia braman’ el Bremeno <br/>
        Ofte manĝis radikojn de kreno. <br/>
        Estis pro ritual’, <br/>
        Sed en kruda real’ <br/>
        Tion faris li kun abomeno.
      </p>

      <p class="poem-block mb-3">
        Obeema braman’ el Bremeno <br/>
        Longe sidis en grava kunveno. <br/>
        Estis longa palavr’… <br/>
        Li ne iĝis kadavr’, <br/>
        Sed lin trafis terura migreno.
      </p>
      
      <p class="poem-block mb-3">
        La hardita bramano Bremena <br/>
        Ĉiam iris en vesto fustena. <br/>
        Dum varmego kaj frid’ <br/>
        Restis li en tepid’ <br/>
        Ja koton’ estas ĉiam konvena.
      </p>

    </div>
    `
  )
}

const itemName = {
  esp: 'Aventuroj de iu migrinto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemVideo: ['nPWFrrOe1dY'],
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;